import templateUrl from "emun.invoice/inv/inv-details.htm";
import controller from "emun.invoice/inv/inv-details.controller";
import "emun.invoice/inv/inv-details.scss";

export default {
  bindings: {
    invoiceId: "@",
    mode: "@"
  },
  require: {
    container: "^?invContainer",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};